import FakeFontAwesome from "./FakeFontAwesome.vue";

export default {
  install(Vue) {
    // Add a component
    Vue.component("FIcon", FakeFontAwesome);
  }
};
